import { renderReact } from 'hypernova-react'
import { LogoContainerWithStore } from '../../components/header/logo/logoWithStore.container'
import { RecommendedPostsWithStore } from '../../components/recommendedPosts/recommendedPostsWithStoreContainer'
import { MenuWithStoreComponent } from '../../components/header/menu/menuWithStore.container'
import { MenuButtonWithStoreComponent } from '../../components/header/menu/menuButtonWithStore.container'
import { NavigationContainerWithStore } from '../../components/header/navigation/NavigationWithStore.container'
export function initCommonComponents() {
  renderReact('LogoContainer', LogoContainerWithStore)
  renderReact('RecommendedPostsContainer', RecommendedPostsWithStore)
  renderReact('MenuButtonContainer', MenuButtonWithStoreComponent)
  renderReact('MenuContainer', MenuWithStoreComponent)
  renderReact('NavigationContainer', NavigationContainerWithStore)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/entry_points/common/common.js